module.exports = __webpack_public_path__ + "static/media/intro.735bfd2a.mp3";